import { Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';

import {
  addAttribute,
  addClass,
  hasClass,
  removeAttribute,
  removeClass,
} from '../../helpers/helpers';
import { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-filter-item',
  styleUrl: 'cms-filter-item.scss',
  shadow: true,
})
export class CmsFilterItem {
  @State() open = false;

  private transitionSpeed = 300;

  private filterDetails: HTMLElement;

  private filterSummary: HTMLElement;

  private filterContent: HTMLElement;

  private isClosingClass = 'is-closing';

  private isClosedClass = 'is-closed';

  /**
   * set open or closed
   */
  @Prop({ mutable: true, reflect: true }) closeThis = false;

  /**
   * Property for the accordion headline
   */
  @Prop() filterHeadline!: string;

  /**
   * reference the host element
   */
  @Element() hostElement: HTMLElement;

  @Watch('closeThis')
  onCloseAllChange(newValue: boolean) {
    if (newValue) {
      this.closeFilter();
      this.open = false;
    }
  }

  private setTransitionDuration(node: HTMLElement): void {
    node.style.transitionDuration = this.transitionSpeed + 'ms';
  }

  private setFilterDetailsHeight(node: HTMLElement): void {
    if (this.filterSummary.clientHeight !== null) {
      node.style.height = `${this.filterSummary.clientHeight}px`;
    }
  }

  private toggleFilter(event?: Event): void {
    event?.preventDefault();
    if (!this.closeThis) {
      this.open ? this.closeFilter() : this.openFilter();
      this.open = !this.open;
    }
  }

  private openFilter(): void {
    addAttribute(this.filterDetails, 'open');
    removeClass(this.filterDetails, this.isClosedClass);
    this.filterDetails.style.height = `${
      this.filterSummary.clientHeight + this.filterContent.clientHeight + 24
    }px`;
  }

  private closeFilter(): void {
    addClass(this.filterDetails, this.isClosingClass);
    this.filterDetails.style.height = `${this.filterSummary.clientHeight}px`;
    window.setTimeout(this.isClosing, this.transitionSpeed);
  }

  private isClosing = (): void => {
    if (!hasClass(this.filterDetails, this.isClosingClass)) {
      return;
    }
    removeAttribute(this.filterDetails, 'open');
    removeClass(this.filterDetails, this.isClosingClass);
    addClass(this.filterDetails, this.isClosedClass);
    this.closeThis = false;
  };

  private detailsClassMap(): CssClassMap {
    return {
      ['is-open']: this.open,
      ['filter-details']: true,
    };
  }

  componentDidLoad(): void {
    const hostElement = this.hostElement.shadowRoot;
    this.filterDetails = hostElement?.querySelector('.filter-details');
    this.filterSummary = hostElement?.querySelector('.filter-summary');
    this.filterContent = hostElement?.querySelector('.filter-details-content');
    this.setTransitionDuration(this.filterDetails);
    this.setFilterDetailsHeight(this.filterDetails);
  }

  render() {
    return (
      <Host open={this.open}>
        <div>
          <details class={this.detailsClassMap()}>
            <summary
              onClick={(event) => this.toggleFilter(event)}
              class='filter-summary'
            >
              <div class='filter-headline'>{this.filterHeadline}</div>
              <div class='svg-icon-wrapper'>
                <cms-icon
                  size='md'
                  icon={this.open ? 'countMinus' : 'countPlus'}
                  colorToken={'--cms-semanticColors-base-strong-icon'}
                ></cms-icon>
              </div>
            </summary>
            <div
              onClick={(event) => this.toggleFilter(event)}
              class='filter-details-content'
            >
              <slot name='filter-content' />
            </div>
          </details>
        </div>
      </Host>
    );
  }
}
